module.exports = __webpack_public_path__ + "static/media/teddy.5fe56ab0.png";